import { find, sortBy, uniqBy } from 'lodash';
import { useCallback, useMemo } from 'react';
import { useActivities } from 'store/activities/selectors';
import { booksAllList } from 'store/books/reducers';
import { useAllBook } from 'store/books/selectors';
import { useClassActivities } from 'store/classActivities/selectors';
import { useClassQuizzes } from 'store/classQuizzes/selectors';
import { useClassGameActivity } from 'store/one_game/selectors';
import { useResources } from 'store/resources/selectors';
import { imageFetchDinamic, imageFetchFromPodcast } from 'utils/lib/ebookHelper';

export const useNotificationPageCover = () => {
  const bookAllList = useAllBook();
  const resources = useResources();
  const activites = useActivities();
  const classActivities = useClassActivities();
  const classQuizzes = useClassQuizzes();
  const { class_game_activity } = useClassGameActivity();
  const all_activities = useMemo(() => {
    return [...classActivities, ...classQuizzes, ...class_game_activity];
  }, [classActivities, classQuizzes, class_game_activity]);

  const findBookBookId = (chapter) => {
    if (!chapter) return null;
    const sortById = sortBy(bookAllList, 'id');
    const book = find(sortById, { id: chapter });
    return book;
  };

  const pageCover = (notificationAssignmentData,activeAssignment) => {
    try {
      const storedPageCoverUrl = activeAssignment?.data?.meta_data?.book_info?.page_cover_url || notificationAssignmentData?.meta_data?.book_info?.page_cover_url;
      if (storedPageCoverUrl) {
        return storedPageCoverUrl;
      }
      const assignmentData = find(activites, { id: notificationAssignmentData?.id }) || notificationAssignmentData;
      const is_engage = assignmentData?.config_assignment?.isFrom === 'engagement';
      const findActivity = find(all_activities, { activityId: assignmentData?.data?.id || assignmentData?.id });
      if(findActivity?.meta_data?.book_info?.page_cover_url) {
        return findActivity?.meta_data?.book_info?.page_cover_url;
      }
      let _chapter = assignmentData?.chapter ? assignmentData?.chapter : assignmentData?.data?.chapter;
      let _page = assignmentData?.page ? assignmentData?.page : assignmentData?.data?.page;
      if (!_chapter) {
        _chapter = assignmentData?.book_id;
      }
      if (!_page) {
        _page = assignmentData?.page_id;
      }

      if (is_engage) {
        const is_engage = notificationAssignmentData?.config_assignment?.isFrom === 'engagement';
        if (is_engage) {
          const chapterId = notificationAssignmentData?.chapter;
          if (!chapterId) {
            return null;
          }

          const sortById = sortBy(booksAllList, 'id');
          const book = find(sortById, (b) => String(b?.id) === String(chapterId));
          if (!book?.engage || !Array.isArray(book.engage)) {
            return null;
          }

          const engageId = notificationAssignmentData?.config_assignment?.engage_id;
          if (!engageId) {
            return null;
          }

          const engage = find(book.engage, (e) => String(e?.id) === String(engageId));
          if (!engage?.imageData || !Array.isArray(engage.imageData) || engage.imageData.length === 0) {
            return null;
          }

          const sequenceOrder = notificationAssignmentData?.config_assignment?.sequence_order;
          if (!sequenceOrder) {
            return null;
          }

          const findImageData = find(engage.imageData, (img) =>
            String(img?.id) === String(sequenceOrder)
          );
          return findImageData?.resource || null;
        }
      }
      else {
        let url = imageFetchFromPodcast(_chapter, resources) ? imageFetchFromPodcast(_chapter, resources) : imageFetchDinamic(_chapter, _page, bookAllList)?.resource
        return url;
      }
    } catch (error) {
      return null;
    }
  }

  return { pageCover };
};
